import React from 'react'
import { Button } from '@/components/button'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import { useLocalization } from '@/hooks/localization'

export const TaskButton = React.memo(
  function TaskButton ({ text, value, icon, confirmText, confirmTitle, onClick, disabled, onlyShow, cssClass }) {
    const loading = disabled === true || value === disabled

    const { localize } = useLocalization()

    return (
      <Button
        size='sm'
        color={getResponseColor(cssClass)}
        onClick={() => onClick(value)}
        confirmText={confirmText}
        confirmTitle={confirmTitle}
        disabled={disabled || onlyShow}
        title={onlyShow ? localize('Tasks.StartTask') : ''}>
        {icon ? (
          <React.Fragment>
            <Icon name={loading && !onlyShow ? 'loader bx-spin' : icon} /><span><Resx name={text} /></span>
          </React.Fragment>
        ) : (
          <Resx name={text} />
        )}
      </Button>
    )
  })

function getResponseColor (cssClass) {
  let color = ''
  switch (cssClass) {
    case 'btn-danger':
      color = 'danger'
      break
    case 'btn-warning':
      color = 'warning'
      break
    case 'btn-success':
      color = 'success'
      break
    case 'btn-primary':
      color = 'primary'
      break
    default:
      break
  }
  return color
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/tasks/taskButton.js